<template>
  <div>
    <v-card>
      <v-card-title>
        <div>
          <div class="headline">Privilege Group Listing</div>
        </div>
        <v-spacer></v-spacer>
        <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
      </v-card-title>
      <v-data-table v-bind:headers="headers" v-bind:items="items" v-bind:search="search" :rows-per-page-items="itemsPerPage" v-bind:pagination.sync="pagination" item-key="name" :loading="loading" :no-data-text="noDataText" :filter="customSearch">
        <template slot="headerCell" slot-scope="props">
          <v-tooltip bottom>
            <span slot="activator">
              {{ props.header.text }}
            </span>
            <span>
              {{ props.header.text }}
            </span>
          </v-tooltip>
        </template>
        <template slot="items" slot-scope="props">
          <td class="text-xs-left">{{ props.item.privilegeGrpId }}</td>
          <td class="text-xs-left">{{ props.item.description }}</td>
          <td class="text-xs-left">{{ props.item.parentId }}</td>
          <td class="text-xs-left">{{ props.item.seq }}</td>
          <td class="text-xs-right">
            <table-action :rowData="props" review @review="doReview" @remove="doPromptRemove(props.item)"></table-action>
          </td>
        </template>
      </v-data-table>
    </v-card>
    <confirm v-model="promptRemove" @ok="doRemove">
          Are you sure that you want to delete the selected Privilege Group? ({{deleteUserPrivilegesGrp}})
    </confirm>
    <div class="pt-2">
      <v-btn color="primary" @click.native="doNewPrivilegeGrp">
        New Privilege Group
        <v-icon right>mdi-plus</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { expandURI } from '@/utils/ajax'
import MessageMixin from '@/mixins/message'

export default {
  data() {
    return {
      headers: [
        { text: 'Privilege Group ID', value: 'privilegeGrpId' },
        { text: 'Privilege Group Description', value: 'description' },
        { text: 'Parent ID', value: 'parentId' },
        { text: 'Sequence', value: 'seq' },
        TableConst.tableActionHeader
      ],
      promptRemove: false,
      selectedPrivilegeGrp: undefined,
      deleteUserPrivilegesGrp: ''
    }
  },
  computed: {
    privilege() {
      return this.$store.state.adminUser.privilege
    }
  },
  methods: {
    async init() {
      this.loading = true
      const apiURI = this.privilege.menu.userPrivilegesGrps
      if (apiURI) {
        try {
          const result = await this.$http.get(apiURI)
          const { data } = result.data
          if (data) {
            this.items = []
            data.map((privilegeGrp) => {
              const convertPrivilegeGrp = {
                privilegeGrpId: privilegeGrp.privilegeGrpId,
                parentId: privilegeGrp.parentId,
                description: privilegeGrp.description,
                seq: privilegeGrp.seq
              }
              this.items.push(convertPrivilegeGrp)
            })
            this.loading = false
          }
        } catch (error) {
          this.loading = false
        }
      } else {
        this.loading = false
      }
    },
    doReview(data) {
      if (data && data.item) {
        this.$router.push({ name: 'privilegesReview', params: { id: data.item.privilegeGrpId } })
      }
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedPrivilegeGrp = data
        this.deleteUserPrivilegesGrp = data.privilegeGrpId + ' - ' + data.description
      }
    },
    async doRemove() {
      const apiURI = this.privilege.menu.deleteUserPrivilegesGrp
      if (apiURI) {
        this.loading = true
        const expand = {
          privilegeGrpId: this.selectedPrivilegeGrp.privilegeGrpId
        }
        try {
          const result = await this.$http.delete(expandURI(apiURI, expand))
          this.notify(result.data)
          this.init()
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    },
    doNewPrivilegeGrp() {
      this.$router.push({ name: 'privilegesReview', params: { id: 'new' } })
    }
  },
  mounted() {
    this.init()
  },
  mixins: [
    TableConst.default,
    MessageMixin
  ]
}
</script>

<style>

</style>
